/*  eslint-disable no-unused-vars */
import { useContext, useRef, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import {
  Avatar,
  Box,
  Button,
  ButtonBase,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
  Typography
} from '@material-ui/core';
import useAuth from '../../hooks/useAuth';
import UserIcon from '../../icons/User';
import { ChatContext } from '../../contexts/ChatContext';
import constants from '../../utils/constants';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';

const AccountPopover = () => {
  const anchorRef = useRef(null);
  const { user, logout } = useAuth();
  const { lastBalance } = useContext(ChatContext);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      await logout();
      navigate('/');
    } catch (err) {
      console.error(err);
      toast.error('Unable to logout.');
    }
  };

  return (
    <>
      <Box
        component={ButtonBase}
        onClick={handleOpen}
        ref={anchorRef}
        sx={{
          alignItems: 'center',
          display: 'flex'
        }}
      >
        <Avatar
          src={`${process.env.REACT_APP_BASE_URL_PURE}${user.profilePicture}`}
          sx={{
            height: 32,
            width: 32
          }}
        />
      </Box>
      <Popover
        className="account-popover"
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom'
        }}
        keepMounted
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: 240 }
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography
            color="textPrimary"
            variant="body1"
            fontWeight={500}
          >
            {user.fullName}
          </Typography>
          {/* <Typography
            color="textSecondary"
            variant="body1"
            display="inline"
            fontWeight={500}
          >
            Bakiye:
          </Typography>
          <Typography
            color="textPrimary"
            variant="body1"
            display="inline"
            fontWeight={500}
            sx={{ pl: 2 }}
          >
            {`${lastBalance?.balance?.toLocaleString(constants.defaultCulture) || '-'} ${lastBalance?.currency || constants.defaultCurrency}`}
          </Typography> */}
        </Box>
        <Divider />
        <Box sx={{ mt: 2 }}>
          <MenuItem
            component={RouterLink}
            to="/account?tab=profile"
          >
            <ListItemIcon>
              <UserIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={(
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                  component={RouterLink}
                  to="/account?tab=profile"
                >
                  Hesap Ayarları
                </Typography>
              )}
            />
          </MenuItem>
          <MenuItem
            component={RouterLink}
            to="/account?tab=profile"
          >
            <ListItemIcon>
              <ContactPhoneIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={(
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                  component={RouterLink}
                  to="/contactus"
                >
                  Bize Ulaşın
                </Typography>
              )}
            />
          </MenuItem>
        </Box>
        <Box sx={{ p: 2 }}>
          <Button
            color="primary"
            fullWidth
            onClick={handleLogout}
            variant="outlined"
          >
            Çıkış Yap
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default AccountPopover;
